
// H5登录-开启注册-白名单
export const H5_LOGIN_WHITE_LIST = new Set([
                          "200023915",
                          "200027687",
                          "200028062",
                          "200028909",
                          "200029004"]);

// client登录-关闭注册-白名单-默认开启
export const CLIENT_LOGIN_WHITE_LIST = new Set([
                          "200024951",
                          "200025297",
                          "200025295"]);

// client登录-开启自动登录-白名单
export const CLIENT_AUTOLOGIN_WHITE_LIST = new Set([
                          "200024245"]);

// 临时修改-模拟器开启注册-白名单
export const MONITOR_REGISTER_WHITE_LIST = new Set([
                          "200028999",
                          "200028643",
                          "200028644",
                          "200029002",
                          "200028645",
                          "200031775"]);

// client登录-关闭手机登录-白名单-默认开启
export const CLIENT_LOGIN_WHITE_ONLY_REG_LIST = new Set([
                          "200028505",
                          "200028506",
                          "200028507",
                          "200028508",
                          "200028999",
                          "200029000",
                          "200029001",
                          "200029002",
                          "200030088",
                          "200030089",
                          "200030090",
                          "200030091",
                          "200030092",
                          "200028509"]);
            
// 天穹支付参数 - 使用模板引用
const TQ_CONFIGS =  {
    // android-烈焰天地-200029834 tq9h6w2y8egwusxutu59 888066d8b7fe889eb8a09dd9cb3a0224
  "200029834": {
    "tq_app_id": "tq9h6w2y8egwusxutu59",
    "client_secret": "888066d8b7fe889eb8a09dd9cb3a0224",
    "tq_order_prefix": "lytd"
  },
  // android-神龙战士-200029835 tqqctrshpy2k930p3udy be5a00b94017687a8bb80b6998268c18
  "200029835": {
    "tq_app_id": "tqqctrshpy2k930p3udy",
    "client_secret": "be5a00b94017687a8bb80b6998268c18",
    "tq_order_prefix": "slzs"
  },
  // android-太古传奇-七绝-200030356 tqafx15oapv7rd4c9x2f 6ef63647c82206ec06ba77f445eca5ba
  "200030356": {
    "tq_app_id": "tqafx15oapv7rd4c9x2f",
    "client_secret": "6ef63647c82206ec06ba77f445eca5ba",
    "tq_order_prefix": "qj"
  },
  // android-太古传奇-倾国之怒-200030357 tq362ucy88loqvdk8qgj 1a79c7b26f7196f0017e88daa67af9f1
  "200030357": {
    "tq_app_id": "tq362ucy88loqvdk8qgj",
    "client_secret": "1a79c7b26f7196f0017e88daa67af9f1",
    "tq_order_prefix": "qgzn"
  },
  // android-雷霆纪元-200031778 tq2s1mxrc3967m6rcbed ffca6b40cd6c2c66b441ee87890f323e ltjy
  "200031778": {
    "tq_app_id": "tq2s1mxrc3967m6rcbed",
    "client_secret": "ffca6b40cd6c2c66b441ee87890f323e",
    "tq_order_prefix": "ltjy"
  },
  // android-乱舞江山-200032710	tqhiayjt3oys76zd8k8t 05164876d2bdf51e1566253e93259918 lwjs
  "200032710": {
    "tq_app_id": "tqhiayjt3oys76zd8k8t",
    "client_secret": "05164876d2bdf51e1566253e93259918",
    "tq_order_prefix": "lwjs"
  },
  // ios-乱舞江山-200032714 tq24kjd6ze056ea00u2a	e489bc0f75bd8792ccf6c2151528469b lwjs
  "200032714": {
    "tq_app_id": "tq24kjd6ze056ea00u2a",
    "client_secret": "e489bc0f75bd8792ccf6c2151528469b",
    "tq_order_prefix": "lwjs"
  },
  // android-笑傲仙途-200032809	tqtg4r4i0u0tng1psfi2 d3cdf25409248f40723f8f51d1bb8f3f xaxt
  "200032809": {
    "tq_app_id": "tqtg4r4i0u0tng1psfi2",
    "client_secret": "d3cdf25409248f40723f8f51d1bb8f3f",
    "tq_order_prefix": "xaxt"
  },
  // 新增5个appkey - 全部引用zlyx模板
  "200033181": "zlyx",
  "200033182": "zlyx",
  "200033183": "zlyx",
  "200033184": "zlyx",
  "200033185": "zlyx"
};

// 天穹支付参数配置模板
const TQ_CONFIG_TEMPLATES = {
  // 真龙英雄 - 新增5个appkey共用
  "zlyx": {
    "tq_app_id": "tq7g4zqb5e4ixsd2pqvf",
    "client_secret": "c54adb41c086b8bd5e62a17e804818e7",
    "tq_order_prefix": "zlyx"
  }
};

// 导出天穹支付参数（自动展开模板引用）
export const APPKEY_PARAMS = Object.entries(TQ_CONFIGS).reduce((acc, [key, value]) => {
  // 如果是字符串，从模板中获取配置并深拷贝
  if (typeof value === 'string' && TQ_CONFIG_TEMPLATES[value]) {
    acc[key] = { ...TQ_CONFIG_TEMPLATES[value] };
  } else {
    acc[key] = value;
  }
  return acc;
}, {});
